const slogans = [
  "What a text input from 2019 should be",
  "Not your grandpa's input field",
  "Not a hoverboard, but a very nice text input",
  "Genetically modified text input for modern web",
];

export default slogans[Math.round(Math.random() * (slogans.length - 1))];
